import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-market-loss-filter',
  templateUrl: './market-loss-filter.component.html',
  styleUrls: ['./market-loss-filter.component.scss']
})
export class MarketLossFilterComponent {
  @Input() checked = false;

  @Output() filter = new EventEmitter<void>();
  @Output() checkedChange = new EventEmitter<any>();

  onEnter(): void {
    this.filter.emit();
  }

  onChange(target: any): void {
    this.checkedChange.emit(target);
  }
}
